// OrderList.js
import React, { useEffect, useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import searchIcon from '../../../../Assets/icons/searchicon.svg';
import ROUTES_NAVIGATION from '../../../../routes/routes';
import Loader from '../../../customComponents/CustomLoader';
import axiosInstance from '../../../services/api/API';
import ListLogisticsFilters from '../../Logistics/LogisticsFilter';
import OrderCard from './OrderCard';
import './OrderList.scss';

const OrderList = () => {
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("authToken");
  const dealer_id = localStorage.getItem("dealerId");
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalProducts,setTotalProducts] = useState(0)
  

  const [colorOptions, setColorOptions ] = useState([])

  const [modelOptions, setModelOptions] = useState([]);

  const [ filterFormData, setFilterFormData ] = useState({})
  const [validationErrors, setValidationErrors] = useState({});
  const [ filters, setFilters ] = useState({})

  const [ itemCategoryOption , setItemcategoryOptions ] = useState([])
  const [accessoryOptions, setaccessoryOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);

  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
    console.log("clicked");
    setFilterFormData({})
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // setFilterFormData({})
  };
  // useEffect(() => {
  //   if (searchTerm === "") {
  //     fetchProductList();
  //   }
  // }, []);

  // const fetchProductList = async (page = 0, pageSize = 10) => {
  //   const allfilteredData = filters;
  //   try {
  //     setLoading(true);
  //     const response = await axiosInstance.post(
  //       '/sales/salesproductlist',
  //       {
  //         orderBy: 'variant_id desc',
  //         page,
  //         pageSize,
  //         searchText: searchTerm,
  //         searchType: allfilteredData?.itemType?allfilteredData?.itemType:null ,
  //         modelId: allfilteredData?.model?allfilteredData?.model:0 ,
  //         variantId: allfilteredData?.variant?allfilteredData?.variant:0 ,
  //         itemCateId: allfilteredData?.category?allfilteredData?.category:0 ,
  //         itemId: allfilteredData?.accessory?allfilteredData?.accessory:0 ,
  //         colorId: allfilteredData?.color?allfilteredData?.color:0 ,
          
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         }
  //       }
  //     );
  //     const orderData = response?.data?.data?.data || [];
    
  //    setTotalProducts(response?.data?.data?.countdata?.total) 
  //    console.log("totalProducts",response?.data?.data?.countdata);
     
  //     setOrders(orderData);
  //   } catch (error) {
  //     console.error('Error fetching product list:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchProductList = async (page = 0, pageSize = 20) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        '/sales/salesproductlist',
        {
          orderBy: 'variant_id desc',
          page,
          pageSize,
          searchText: searchTerm || null,
          searchType: filters?.itemType || null,
          modelId: filters?.model || null,
          variantId: filters?.variant || null,
          itemCateId: filters?.category || null,
          itemId: filters?.accessory || null,
          colorId: filters?.color || null,
          dealer_id: parseInt(dealer_id),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const orderData = response?.data?.data?.data ;
      setTotalProducts(response?.data?.data?.countdata?.total);
      setOrders(orderData); // Update the orders state
    } catch (error) {
      console.error('Error fetching product list:', error);
    } finally {
      setLoading(false);
    }
  };
  
  
  const handleSearch = (e) => {

    const term = e.target.value;
    setSearchTerm(term);
    
   
  };



  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      fetchProductList();
    }
  };

  const clearSearch = () => {
    // setSearchTerm('');
    setSearchTerm("")
    fetchProductList(); 
  };
console.log("orderdata",orders);

const PhysicalStockTakingInputs = [
  {
    name: "itemType",
    label: "Item Type",
    placeholder:"Enter ",
    type: "dropdown",
    options:[
        { value: "V", label: "Vehicle" },
        // { value: "A", label: "Accessories" },
        // { value: "SP", label: "Spare Part" },
      ],
    // required: true,
    gridClass: "col-lg-5",
    
  },
  ...( filterFormData.itemType === "V" || filterFormData.itemType == "SP"
    ? 
    [
      {
        name: "model",
        label: "Model",
        type: "dropdown",
        options: modelOptions,
        validation: {
          // required: true,
        },
        // required: true,
        gridClass: "col-lg-5",
      },
  ]: []
  ),
  {
    name: "color",
    label: "Color",
    type: "dropdown",
    // required: true,
    options: colorOptions,
    // validation: {
    //   required: true,
    // },
    gridClass: "col-lg-5",
  },
  ...( filterFormData.itemType === "V" 
    ? 
    [
      {
        name: "variant",
        label: "Variant",
        placeholder:"",
        type: "dropdown",
        options:variantOptions,
        // required: true,
        gridClass: "col-lg-5",
        
      },
  ]: []
  ),
  ...( filterFormData.itemType !== "V" 
    ? 
    [
    // {
    //     name: "category",
    //     label: "Category",
    //     placeholder:"",
    //     type: "dropdown",
    //     options:itemCategoryOption,
    //     // required: true,
    //     gridClass: "col-lg-5",
        
    //   },
  ]: []
  ),
  ...( filterFormData.itemType !== "V" 
    ? 
    [
        // {
        //     name: "accessory",
        //     label: "Item Name",
        //     placeholder:"",
        //     type: "dropdown",
        //     options:accessoryOptions,
        //     // required: true,
        //     gridClass: "col-lg-5",
            
        //   },
  ]: []
  ),
 
]


// const handleSearchFilter = () => {
//   // Update the filters state with the current form data
//   setFilters({
//     itemType:filterFormData.itemType || "",
//     model:filterFormData.model || null,
//     variant:filterFormData.variant || null,
//     category: filterFormData.category || null,
//     accessory: filterFormData.accessory || null,
//     color: filterFormData.color || null,
//   });
//   fetchProductList();
// };

// const handleSearchFilter = () => {
//   const updatedFilters = {
//     itemType: filterFormData.itemType || "",
//     model: filterFormData.model || null,
//     variant: filterFormData.variant || null,
//     category: filterFormData.category || null,
//     accessory: filterFormData.accessory || null,
//     color: filterFormData.color || null,
//   };

//   setFilters(updatedFilters);

//   fetchProductList(0, 10, updatedFilters);
// };

// const handleSearchFilter = () => {
//   // Update the filters state with the current form data
//   setFilters({
//     itemType:filterFormData.itemType || "",
//     model:filterFormData.model || null,
//     variant:filterFormData.variant || null,
//     category: filterFormData.category || null,
//     accessory: filterFormData.accessory || null,
//     color: filterFormData.color || null,
//   });
//   // fetchProductList();
//   closeModal()
// };
useEffect(() => {
  fetchProductList(0, 10); 
}, [filters]);

const handleSearchFilter = () => {
  setFilters({
    itemType: filterFormData.itemType || '',
    model: filterFormData.model || null,
    variant: filterFormData.variant || null,
    category: filterFormData.category || null,
    accessory: filterFormData.accessory || null,
    color: filterFormData.color || null,
  });
  setIsModalOpen(false); // Close modal after applying filters
};

const clearFilter = () => {
  setFilterFormData({});
  setFilters({});
  setSearchTerm("")
};

// useEffect(() => {
//   setFilterFormData({
//     itemType:"V"
//   })
// },[])

useEffect(() => {

  const modelId = filterFormData.model;
  const colorIdVal = filterFormData.color

  if(modelId && colorIdVal){
    fetchVariantOptions(modelId , colorIdVal)
  }

  //fetchVariantOptions();
}, [filterFormData.model, filterFormData.color ]);

const fetchVariantOptions = async (modelId , colorIdVal) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await axiosInstance.post(
      "/variant/ddlvariant",
      {
        model_id:modelId,
        //  dealer_id:dealer_id
        color_id: colorIdVal,
        dealer_id: parseInt(dealer_id),
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const options = response.data.data.data?.map((variant) => ({
      label: variant.NAME,
      value: variant.ID,
    }));
    setVariantOptions(options);
  } catch (error) {
    console.error("Error fetching variant options:", error);
  }
};

useEffect(() => {
  fetchItemCategoryOptions()
},[])


useEffect(() => {

  const itemTypeVal = filterFormData.itemType
  const categoryId = filterFormData.category

  if(itemTypeVal  && categoryId ){
    fetchItemOptions(itemTypeVal, categoryId )
  } 

},[filterFormData.itemType, filterFormData.category])


const fetchItemOptions = async ( itemTypeVal, categoryId ) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await axiosInstance.post(
      "/item/ddlitem",
      { 
        itemtype: itemTypeVal,
        category_id: categoryId
       },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const options = response.data.data.data?.map((variant) => ({
      label: variant.NAME,
      value: variant.ID,
    }));
    setaccessoryOptions(options);
  } catch (error) {
    console.error("Error fetching variant options:", error);
  }
};


const fetchItemCategoryOptions = async () => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await axiosInstance.post(
      "/partcategory/ddlpartcategory",
      { 
        // itemtype: itemTypeVal,
        // variant_id:variantId,
       },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const options = response.data.data.data?.map((variant) => ({
      label: variant.NAME,
      value: variant.ID,
    }));
    setItemcategoryOptions(options);
  } catch (error) {
    console.error("Error fetching variant options:", error);
  }
};

useEffect(() => {
  fetchColorOptions()
},[])

const fetchColorOptions = async () => {
  try {
    const payload = {
    
      page: 0,
      pageSize: 100,
      // make_id: makeId,
    };

   

    const response = await axiosInstance.post("/color/ddlcolor", payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const options = response.data.data.data.map((color) => ({
      label: color.NAME,
      value: color.ID,
    }));

    setColorOptions(options);
  } catch (error) {
    console.error("Error fetching model options:", error);
  }
};

useEffect(() => {
  fetchModelOptions()
},[])

const fetchModelOptions = async () => {
  try {
    const payload = {
      orderBy: "model_id desc",
      page: 0,
      pageSize: 100,
    };

    const response = await axiosInstance.post("/model/ddlmodel", payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const options = response.data.data.data.map((model) => ({
      label: model.NAME,
      value: model.ID,
    }));

    setModelOptions(options);
  } catch (error) {
    console.error("Error fetching model options:", error);
  }
};

  return (

    <div>

{loading ? ( 
        <Loader />
      ) : (
        <>
        <div className='OnboardManagamentContainer row'>
          {/* <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'> */}
          <div className='product-list-headers'>
            <div>
            <h5>Product List</h5>
            </div>
          {/* </div> */}
          {/* <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'> */}
            <div>
              <button className='addcustomerbutton' onClick={() => navigate(ROUTES_NAVIGATION.GENERATEORDER)}>
                Create Order
              </button>
            </div>
          </div>
          {/* </div> */}
        </div>
        <div className="order-list">
          <div className='productsearchbarcontainer' style={{justifyContent:"space-between"}}> 
            <div style={{display:"flex", justifyContent:"flex-start", alignItems:"center", gap:"15px"}}>
            <h5 className='ordertitle'>Product List</h5> 
            <div className="order-search-bar">
              <div>
              <input
                type="text"
                placeholder="Search Product"
                value={searchTerm}
                onChange={handleSearch}
                onKeyDown={handleKeyDown} 
                className="search-input"
              />
              {searchTerm ? (
                <IoMdClose className="close-icon"  onClick={clearFilter} />
              ) : (
                <img onClick={clearFilter} src={searchIcon} alt="Search Icon" className="search-icon" />
              )}
              </div>
            </div>
            </div>
  {/* Filter */}
            <div style={{display:"flex", gap:"10px", alignItems:"center"}}  >
            <div style={{marginBottom:"9px"}} className="mt-3">
                <button
          style={{ padding: "10px 35px" }}
          className="clear-btn"
          onClick={clearFilter}
        >
          Clear
        </button>
          </div>
                <div  style={{ gap:"10px", alignItems:"center"}} className="mt-3">
                <button
          style={{ padding: "10px 35px" }}
          className="submit-btn"
          onClick={openModal}
        >
          Filters
        </button>
          </div>
          {isModalOpen && (
          <div className="custom-modal-overlay-orderCard" >
            <div className="custom-modal" >
              <div className="custom-modal-header">
                <h6 style={{ fontSize: "18px" }}>Filter</h6>
                <button className="close-button" onClick={closeModal}>
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
              <ListLogisticsFilters
        formConfig={PhysicalStockTakingInputs} 
        formData={filterFormData}
        setFormData={setFilterFormData}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        handleSearch={handleSearchFilter}
        handleClear={clearFilter}
        />
              </div>
              {/* <div className="custom-modal-footer">
                              <button
                                  className="btn btn-primary"
                                  style={{ background: "#7BD755", color: "white", border: "none", borderRadius:"20px", padding:" 10px 28px" }}
                                  // onClick={handleHold}
                              >
                                  Submit
                              </button>
                              <button className="btn btn-primary"  style={{ background: "white", color: "#7BD755", border: "1px solid #7BD755", borderRadius:"20px", padding:" 10px 28px" }} 
                              onClick={closeModal}
                              >
                                  Cancel
                              </button>
                          </div> */}
            </div>
          </div>
        )}
  
  
  
  {/* {isModalOpen && (
          <div  style={{gap:"10px", alignItems:"center"}} className="custom-modal-overlay-orderCard">
            <div className="custom-modal-orderCard-filter">
              <div className="custom-modal-header-orderCard">
                <h6 style={{fontSize:"19px", fontWeight:"600"}}>Filters</h6>
                <button style={{fontSize:"28px", fontWeight:"600"}} className="close-button" onClick={closeModal}>
                  ×
                </button>
              </div>
              <div style={{display:"flex", flexWrap:"wrap",}} className="custom-modal-body-orderCard">
              //  Dynamic Form
                <ListLogisticsFilters
        formConfig={PhysicalStockTakingInputs} 
        formData={filterFormData}
        setFormData={setFilterFormData}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        handleSearch={handleSearchFilter}
        handleClear={clearFilter}
        />
              </div>
            </div>
          </div>
        )} */}
  
  
              </div>
          </div>
          <div className="order-container">
           
          <OrderCard orders={orders} />
       
          </div>
        </div>
      </>

      )}
    </div>
  );
};

export default OrderList;
